import { spawnDebris, areaDamage, spawnRing } from './fx';
import { hurtPlayer } from './player';
import { SFX } from '../platform/audio';
import { warnBurst } from '../render/warn-fx';
import { P } from '../world/player';
/* ============================================================
   會爆的敵人
   ============================================================

   **2026-08-03 敵人大改版之後這個檔只剩一個函式。**

   原本這裡有第二批敵種的四種行為（自爆機、壓制炮、分裂體）。
   新的四色語彙把它們吸收掉了：壓制炮＝橙・直射（`atk.kind === 'bolt'`），
   分裂體在新的 28 種目錄裡**沒有對應角色**（VS 也沒有分裂型，
   `.claude/notes/vs-enemies.md` 查證過），所以整個拿掉。

   `detonate` 留著，因為 ORB 家族的 **DORN 棘**（紫・自爆・逼位）要用它 ——
   那是規格 §5.1 明列的敵人，只是還沒移植。移植時它的載荷會是
   `atk: { kind: 'fuse', ... }`，引信期間畫紫色預警圈、時間到呼叫這裡。

   ⚠️ 現在沒有任何型別有 `T.boom`，所以這個函式**目前不會被執行**。
   它不是死碼是待接線的內容（同 `data/modules.ts` 的處理方式）。 */

/** 引爆。血量歸零時也會走這裡 —— 打死它一樣會炸（死亡殉爆）。
    正解是拉開距離，不是多補兩發。 */
export function detonate(e) {
  var B = e.T.boom;
  spawnRing(e.pos.x, e.pos.z, 0xff4a3d, 1, B.r * 2.4, 0.42);
  warnBurst(e.pos.x, e.pos.z, B.r, 0xff4a3d);   // 擴散環＝「已經發生了」（規格 §9）
  spawnDebris(e.pos.x, 1.4, e.pos.z, 0xff4a3d, 14, 1.5, 0.6);
  SFX.boom();
  areaDamage(e.pos.x, e.pos.z, B.r, 0, 0xff4a3d, e);   // 不傷敵人：它是衝著玩家來的
  var d = Math.hypot(P.pos.x - e.pos.x, P.pos.z - e.pos.z);
  if (d < B.r && P.alive) hurtPlayer(B.dmg * e.dmgMul, e.y + B.r);   // 自爆是球狀的：觸及高度＝半徑
  e.hp = 0;
}
